import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface PasswordStrengthFlags {
  minLength: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  specialChar: boolean;
}

const MIN_LENGTH = 8;
const SPECIAL_CHAR_PATTERN = /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/;'`~]/;

export function getPasswordStrengthFlags(value: string | null | undefined): PasswordStrengthFlags {
  const password = value ?? '';
  return {
    minLength: password.length >= MIN_LENGTH,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: SPECIAL_CHAR_PATTERN.test(password)
  };
}

export function isPasswordStrengthValid(flags: PasswordStrengthFlags): boolean {
  return Object.values(flags).every(Boolean);
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const flags = getPasswordStrengthFlags(control.value);
    return isPasswordStrengthValid(flags) ? null : { passwordStrength: flags };
  };
}
